/**
 * Mapas base (ADR-0004). IGN Base y PNOA: servicios WMTS del Instituto Geográfico Nacional,
 * CC BY 4.0, sin clave ni coste (verificado en GetCapabilities el 17-09-2026: AccessConstraints
 * «CC BY 4.0 scne.es», Fees «No se aplican condiciones»). OpenStreetMap: respaldo automático.
 */
export type BaseLayerId = 'ign' | 'pnoa' | 'osm';

const IGN_WMTS = (service: string, layer: string, format: 'image/jpeg' | 'image/png') =>
  `https://www.ign.es/wmts/${service}?layer=${layer}&style=default&tilematrixset=GoogleMapsCompatible` +
  `&Service=WMTS&Request=GetTile&Version=1.0.0&Format=${encodeURIComponent(format)}&TileMatrix={z}&TileCol={x}&TileRow={y}`;

const IGN_ATTR = 'Mapa base: <a href="https://www.scne.es/" target="_blank" rel="noopener">CC BY 4.0 scne.es</a>. Sistema Cartográfico Nacional (IGN)';

export interface BaseLayerDef {
  id: BaseLayerId;
  label: string;
  url: string;
  attribution: string;
  maxNativeZoom: number;
  /** capa de etiquetas superpuesta (calles sobre la ortofoto) */
  overlay?: { url: string };
}

export const BASE_LAYERS: BaseLayerDef[] = [
  { id: 'ign', label: 'Mapa', url: IGN_WMTS('ign-base', 'IGNBaseTodo', 'image/jpeg'), attribution: IGN_ATTR, maxNativeZoom: 20 },
  {
    id: 'pnoa', label: 'Ortofoto', url: IGN_WMTS('pnoa-ma', 'OI.OrthoimageCoverage', 'image/jpeg'),
    attribution: 'Ortofoto: <a href="https://www.scne.es/" target="_blank" rel="noopener">CC BY 4.0 scne.es</a>. PNOA (IGN)',
    maxNativeZoom: 20, overlay: { url: IGN_WMTS('ign-base', 'IGNBaseOrto', 'image/png') },
  },
  {
    id: 'osm', label: 'OSM', url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors', maxNativeZoom: 19,
  },
];

export const layerById = (id: string | null): BaseLayerDef => BASE_LAYERS.find((l) => l.id === id) ?? BASE_LAYERS[0];

/**
 * Decide si hay que abandonar una capa: varios errores sin ninguna tesela cargada.
 * Se separa para poder probarlo sin navegador.
 */
export function shouldFallback(state: { errors: number; loads: number }, threshold = 4): boolean {
  return state.loads === 0 && state.errors >= threshold;
}
